import {
  FETCH_SCORES_REQUEST,
  FETCH_SCORES_SUCCESS,
  FETCH_SCORES_FAILURE,
  SAVE_SCORE_REQUEST,
  SAVE_SCORE_SUCCESS,
  SAVE_SCORE_FAILURE,
  CHANGE_SCORE_STATUS_REQUEST,
  CHANGE_SCORE_STATUS_SUCCESS,
  CHANGE_SCORE_STATUS_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  scoresList: [],
  data: null,
  error: null,
  success: false,
};

const scoreMasterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SCORES_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case FETCH_SCORES_SUCCESS:
      return {
        ...state,
        loading: false,
        scoresList: action.payload.data || [],
        success: false,
      };

    case FETCH_SCORES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case SAVE_SCORE_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case SAVE_SCORE_SUCCESS:
      return { ...state, loading: false, data: action.payload, success: true };

    case SAVE_SCORE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CHANGE_SCORE_STATUS_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case CHANGE_SCORE_STATUS_SUCCESS:
      return { ...state, loading: false, success: true };

    case CHANGE_SCORE_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default scoreMasterReducer;
